import * as React from 'react';
import { Edit, useEditContext, useGetList, useTranslate } from 'react-admin';
import { MemberRole } from '../../enums/MemberRole';
import { MembersFormContent } from './membersFormContent';

const editContainerSx = {
  '& .MuiTableBody-root tr:last-of-type td': { borderBottom: 'none' },
  // Przy actions={false} react-admin dodaje margin-top: 1em — naglowek (i strzalka
  // "wroc") siedzial przez to 16px nizej niz na pozostalych ekranach.
  '&& .RaEdit-noActions': { marginTop: 0 },
};

const MembersEditFormInner: React.FC = () => {
  const { record, isLoading } = useEditContext<any>();

  const _rawRole = record?.role ?? record?.roles?.[0] ?? '';
  const _roleKey =
    _rawRole && Object.prototype.hasOwnProperty.call(MemberRole, _rawRole)
      ? String(_rawRole)
      : (Object.entries(MemberRole).find(([, val]) => String(val) === String(_rawRole))?.[0] ?? '');

  const { data: couriers = [], isLoading: isCouriersLoading } = useGetList<any>(
    'commissionCouriers',
    {},
    { enabled: _roleKey === 'COURIER' },
  );

  if (isLoading || (_roleKey === 'COURIER' && isCouriersLoading)) return null;

  return <MembersFormContent mode="edit" record={record} couriers={couriers} />;
};

export const MembersEditTable: React.FC = () => {
  const translate = useTranslate();
  return (
    <Edit
      title={translate('resources.members')}
      actions={false}
      component="div"
      queryOptions={{ enabled: false }}
      sx={editContainerSx}
    >
      <MembersEditFormInner />
    </Edit>
  );
};
